export default "__VITE_ASSET__BUIyYL_u__"